import { forwardRef, type HTMLAttributes } from 'react';

import { cn } from '@/utils/cn';

export type IconWellVariant = 'plain' | 'solid';
export type IconWellSize = 'sm' | 'md' | 'lg';

const SIZES: Record<IconWellSize, string> = {
  sm: 'size-8 rounded-md',
  md: 'size-9 rounded-md',
  lg: 'size-12 rounded-lg',
};

const VARIANTS: Record<IconWellVariant, string> = {
  plain: 'text-brand',
  solid: 'bg-brand text-on-brand',
};

export interface IconWellProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: IconWellVariant;
  size?: IconWellSize;
}

export const IconWell = forwardRef<HTMLSpanElement, IconWellProps>(
  ({ variant = 'plain', size = 'md', className, ...props }, ref) => (
    <span
      ref={ref}
      className={cn(
        'inline-flex shrink-0 items-center justify-center',
        SIZES[size],
        VARIANTS[variant],
        className,
      )}
      {...props}
    />
  ),
);

IconWell.displayName = 'IconWell';
